import { DateTime } from "luxon";

/**
 * Changes schedule intervals according to required preparation time
 */
const shiftDeliveryOrPickupIntervals = (
	intervals: {
		startsAt: DateTime;
		endsAt: DateTime;
	}[],
	preparationTimeMinutes: number
): {
	startsAt: DateTime;
	endsAt: DateTime;
}[] => {
	const result: {
		startsAt: DateTime;
		endsAt: DateTime;
	}[] = [];

	if (intervals.length > 0) {
		for (const interval of intervals) {
			const newStartsAt = interval.startsAt.plus({ minutes: preparationTimeMinutes });

			if (+newStartsAt < +interval.endsAt) {
				result.push({
					startsAt: newStartsAt,
					endsAt: interval.endsAt
				});
			}
		}
	}

	return result;
};

export default shiftDeliveryOrPickupIntervals;
